module.exports = __webpack_public_path__ + "static/media/videocall_icon.702edec1.png";